import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
//import { HomeComponent } from './home/home.component';
import { AngularFireAuthGuard, canActivate, loggedIn, redirectUnauthorizedTo, customClaims, hasCustomClaim } from '@angular/fire/auth-guard';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdminComponent } from './admin/admin.component';
import { AuthrolebasedGuard } from './guard/authrolebased.guard'
//import { FirebaseService } from './service/firebase.service';

//import {  } from './ser'
import { SettingsGlobalComponent } from './settings-global/settings-global.component';
import { KioskComponent } from './modules/kiosk/kiosk.component';
import { QuizComponent } from './modules/quiz/quiz.component';
import { DataComponent } from './modules/data/data.component';
import { HomeComponent } from './home/home.component';

import { MediaComponent } from './modules/media/media.component';
import { LotteryComponent } from './modules/lottery/lottery/lottery.component';
import { LotteryContainerComponent } from './modules/lottery/lottery-container/lottery-container.component';


const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["login"]);

const routes: Routes = [
  {
    path: '', pathMatch: 'full', component: LoginComponent,
  },
  {
    path: 'login', pathMatch: 'full', component: LoginComponent,
  },
  { path: 'home', pathMatch: 'full', component: HomeComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'admin', pathMatch: 'full', component: AdminComponent, canActivate: [AuthrolebasedGuard] },
  { path: 'global', pathMatch: 'full', component: SettingsGlobalComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'kiosk', pathMatch: 'full', component: KioskComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'quiz', pathMatch: 'full', component: QuizComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'datas', pathMatch: 'full', component: DataComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'lottery', pathMatch: 'full', component: LotteryContainerComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'media', pathMatch: 'full', component: MediaComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'statistics', loadChildren: () => import('./modules/statistics/statistics.module').then(m => m.StatisticsModule), canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'usermanagement', loadChildren: () => import('./modules/usermanagement/usermanagement.module').then(m => m.UsermanagementModule), canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'register', loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule), canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'mapcontent', loadChildren: () => import('./modules/mapcontent/mapcontent.module').then(m => m.MapContentModule), canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
  { path: 'accountmanagement', loadChildren: () => import('./modules/accountmanagement/accountmanagement.module').then(m => m.AccountmanagementModule), canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },

  //{ path: 'home', pathMatch: 'full',  component: HomeComponent, ...canActivate(redirectUnauthorizedTo([''])) }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
